/**
 * Cleans and normalizes a name by removing special characters and formatting consistently
 * Used for normalizing referral types, tags, etc.
 */
export function cleanName(name: string): string {
  // Replace non-alphanumeric characters with a space
  const cleaned = name.replace(/[^a-zA-Z0-9]/g, ` `)

  // Trim leading and trailing spaces and replace sequential (1 or more) spaces with "-"
  const trimmed = cleaned.trim().replace(/\s+/g, `-`)

  // Make it all lower-case
  const lowerCased = trimmed.toLowerCase()

  return lowerCased
}
